import { integrationApi } from '@/api';
import { ICRTouchSiteScheduleType } from '@/types/icrTouch';
import spacetime from 'spacetime';
import {
  ICRTouchConnectionScheduleSitesConfig,
  ListIcrTouchConnectionScheduleSalesResponse,
} from '../../../api/v1';

export const hasConfigBeenUpdated = (
  originalConfig: ICRTouchConnectionScheduleSitesConfig,
  newConfig: ICRTouchSiteScheduleType,
): boolean => {
  const convertedNewConfig = newConfig.siteNumbers.includes(null)
    ? null
    : newConfig.siteNumbers.sort().toString();
  const convertedOriginalConfig =
    originalConfig.siteNumbers === null
      ? null
      : originalConfig.siteNumbers.sort().toString();

  if (convertedOriginalConfig !== convertedNewConfig) {
    return true;
  }

  return false;
};

export const calculateLabourPercentage = (
  costs: number,
  sales: undefined | number,
): number | undefined => {
  if (costs <= 0) {
    return 0;
  }

  // avoid Infinity
  if (sales === 0) {
    return undefined;
  }

  if (sales !== undefined) {
    return Number(((costs / sales) * 100).toFixed(2));
  }

  return undefined;
};

export const getICRSalesForDay = (
  startDate: Date,
  salesData: ListIcrTouchConnectionScheduleSalesResponse,
  timezone: string,
): undefined | number => {
  if (!salesData) {
    return undefined;
  }

  const startDateISOShort = spacetime(startDate, timezone).format('iso-short');
  return salesData.data.sales.find(
    (saleItem) =>
      spacetime(saleItem.fromDateTime, 'utc').format('iso-short') ===
      startDateISOShort,
  )?.totalSaleValue;
};

export const haveICRScheduleMapsBeenAdded = async (): Promise<boolean> => {
  try {
    const response =
      await integrationApi().listIcrTouchConnectionScheduleSitesConfig();
    return response.data.length > 0;
  } catch {
    return false;
  }
};
